import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20683afa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox-input__box" }
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-input__box-ripple pointer" }, null, -1))
const _hoisted_4 = ["for"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "checkbox-input__error"
}

import { computed, getCurrentInstance, onMounted, ref } from 'vue';
import { StylesType } from '@/types';
import { ComponentInternalInstance } from '@vue/runtime-core';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCheckboxInput',
  props: /*#__PURE__*/_mergeModels({
    label: {},
    height: { default: '36' },
    styles: {},
    error: {}
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['focus', 'blur', 'input'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

let id = 0;

const props = __props;
const emit = __emit;
const instance: ComponentInternalInstance | null = getCurrentInstance();
const uuid = ref(instance?.uid);

// eslint-disable-next-line no-undef
const checkboxValue = _useModel<boolean>(__props, "modelValue");

const tooltipActive = ref(false);
const checkboxLabel = ref<HTMLElement | undefined>();
const inputHandler = () => {
  checkboxValue.value = !checkboxValue.value;
};

const listeners = computed(() => ({
  input: (e: PointerEvent) => emit('input', e),
  focus: (e: PointerEvent) => emit('focus', e),
  blur: (e: PointerEvent) => emit('blur', e),
}));
const cssProps = computed(() => {
  return {
    '--border': props.styles?.border,
    '--background-color': props.styles?.backgroundColor,
  };
});

onMounted(() => {
  if (checkboxLabel.value) {
    if (checkboxLabel.value.clientWidth < checkboxLabel.value.scrollWidth) {
      tooltipActive.value = true;
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_tooltip = _resolveComponent("base-tooltip")!

  return (_openBlock(), _createBlock(_component_base_tooltip, {
    active: tooltipActive.value,
    "show-in-mobile": false,
    text: _ctx.label
  }, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        style: _normalizeStyle([
        cssProps.value,
        {
          height: _ctx.height + 'px',
        },
      ]),
        class: "checkbox-input",
        onClick: _withModifiers(inputHandler, ["prevent"])
      }, [
        _createElementVNode("span", _hoisted_1, [
          _createElementVNode("span", null, [
            _withDirectives(_createElementVNode("input", _mergeProps({
              id: `checkbox${uuid.value}`,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkboxValue).value = $event)),
              class: "checkbox-input__box-input",
              type: "checkbox"
            }, _toHandlers(listeners.value, true)), null, 16, _hoisted_2), [
              [_vModelCheckbox, checkboxValue.value]
            ]),
            _hoisted_3
          ]),
          _createElementVNode("label", {
            ref_key: "checkboxLabel",
            ref: checkboxLabel,
            for: `checkbox${uuid.value}`,
            class: "checkbox-input__box-label"
          }, [
            _renderSlot(_ctx.$slots, "label"),
            (!_ctx.$slots.label)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.label), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4)
        ]),
        (_ctx.error?.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 3
  }, 8, ["active", "text"]))
}
}

})